import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const PaginationSettingSkeleton = memo(() => {
  return (
    <SettingCardSkeleton
      titleWidth={170}
      controls={["buttons", "buttons", "buttons"]}
    />
  );
});

PaginationSettingSkeleton.displayName = "PaginationSettingSkeleton";

export default PaginationSettingSkeleton;
